import './AppHeader.scss';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import penndotLogo from '../../../images/penndot-logo.png';
import { Navbar, Nav, Container, NavDropdown, Image } from 'react-bootstrap';
import { UserInfo } from '../../../interfaces/userInfo.interafce';
import { LoginManager } from '../../../services/LoginManager';
import { PersonCircle, ArrowLeftCircleFill } from 'react-bootstrap-icons';
import { UserAuthContext, Authorize } from '../appLoginComponent/UserAuthContext'
import { ServerInfo } from '../../../services/ServerInfo';

type TParams = Readonly<{ currentUser: UserInfo, helpFile: string }>;

export function logOut() {
  let manager = new LoginManager();
  manager.signout().then(() => {
    localStorage.clear();
    sessionStorage.clear();
    ServerInfo.get().then((environment) => {
      globalThis.location.href = environment.oidcSettings.post_logout_redirect_uri;
    })
  }
  ).catch((error_: any) => {
  });
}

function getUserIcon(
  currentUser: UserInfo,
  currentUserRole: string,
  mobileUsers: Set<string>,
  isIconHovered: boolean,
  setIsIconHovered: (value: boolean) => void
) {
  if (currentUser.photo.length > 0) {
    return <Image className="cursor-pointer loggedin-user-image" src={currentUser.photo}></Image>;
  }
  if (mobileUsers.has(currentUserRole)) {
    return <PersonCircle size={32} color={isIconHovered ? "#cccccc" : "#FFFFFF"}
      onMouseEnter={() => setIsIconHovered(true)}
      onMouseLeave={() => setIsIconHovered(false)} className="person-circle"></PersonCircle>;
  }
  return <PersonCircle size={48} color={isIconHovered ? "#cccccc" : "#FFFFFF"}
    onMouseEnter={() => setIsIconHovered(true)}
    onMouseLeave={() => setIsIconHovered(false)}></PersonCircle>;
}

function AppHeader({ currentUser, helpFile }: TParams) {

  const location = useLocation();
  const navigate = useNavigate();
  const [docViewerLabel, setDocViewerLabel] = useState('');
  const [isIconHovered, setIsIconHovered] = useState(false);
  const [isBackIconHovered, setIsBackIconHovered] = useState(false);
  let { setCurrentUserRole, setTesterId, isAuthorized, currentUserRole, testerId } = useContext(UserAuthContext) as Authorize;

  // Routes where back button should appear
  const routesWithBackButton = [
    '/mobileView',
    '/docViewer',
  ];


  useEffect(() => {

    setIsBackIconHovered(false);

    const handler = () => {
      const label = sessionStorage?.getItem('docViewerLabel') ?? '';
      setDocViewerLabel(label);
    }
    globalThis.addEventListener('storage', handler);
    setTimeout(handler, 0); handler();
    return () => {
      globalThis.removeEventListener('storage', handler);
    };
  }, [location.pathname])

  useLayoutEffect(() => {
    const label = sessionStorage?.getItem('docViewerLabel') ?? '';
    setDocViewerLabel(label);
    sessionStorage.removeItem('docViewerLabel');
  }, [location.pathname]);

  // Check if current route should show back button
  const shouldShowBackButton = routesWithBackButton.some(route =>
    location.pathname.includes(route)
  );

  const handleBackClick = () => {
    navigate(-1);
  };


  const getPageName = (pathname: string): string => {
    const pathMap: { [key: string]: string } = {
      '/docViewer': docViewerLabel,
    };


    // Normalize pathname by removing trailing slash
    const normalizedPath = pathname.endsWith('/') && pathname !== '/'
      ? pathname.slice(0, -1)
      : pathname;

    // Check for exact match first
    if (pathMap[normalizedPath]) {
      return pathMap[normalizedPath];
    }

    // Check for partial matches (path contains the key)
    for (const [key, value] of Object.entries(pathMap)) {
      if (normalizedPath.includes(key) && key !== '/') {
        return value;
      }
    }

    // Default fallback
    return 'AVIRP-FG';
  };

  const currentPageName: string = getPageName(location.pathname);

  useEffect(() => {
    //Set the current role and tester ID in the auth context so this info is accessible to all child components
    //alert("Current role "+ currentUserRole + testerId);
    if (currentUser.role != currentUserRole) setCurrentUserRole(currentUser.role);
    if (currentUser.testerId != testerId) setTesterId(currentUser.testerId)

  }, [currentUser.role, currentUser.testerId])

  const mobileUsers = new Set(["PD-AVIRP-LawEnforcement", "PD-AVIRP-Firefighting", "PD-AVIRP-EMT", "PD-AVIRP-Towing"]);

  return (
    // dynamic class name based on role
    // if(currentUserRole && mobileUsers.includes(currentUserRole)){
    <Navbar collapseOnSelect bg="primary" variant="dark" className="AppHeader shadow">
      <Container fluid className="d-flex align-items-center">
        {/* Left Section - Back Button */}
        <div className="header-left d-flex justify-content-start align-items-center">
          {shouldShowBackButton && (
            <button
              className="btn btn-link p-0"
              style={{ fontWeight: 900 }}
              onClick={handleBackClick}
              title="Go back"
            >
              <ArrowLeftCircleFill
                size={35}
                strokeWidth={12}
                color={isBackIconHovered ? "#cccccc" : "#FFFFFF"}
                onMouseEnter={() => setIsBackIconHovered(true)}
                onMouseLeave={() => setIsBackIconHovered(false)}
              />
            </button>
          )}
          {!mobileUsers.has(currentUserRole) && !shouldShowBackButton && (
            <Image src={penndotLogo} className="d-none d-lg-block"></Image>
          )}
        </div>

        {/* Center Section - Title */}
        <div className="header-center d-flex justify-content-center align-items-center flex-grow-1">
          {!mobileUsers.has(currentUserRole) && (
            <div className="d-none">
              <h3>AVIRP-FG Web</h3>
            </div>
          )}
          {mobileUsers.has(currentUserRole) && (
            <h5 className="text-white text-center mb-0">{currentPageName}</h5>
          )}
        </div>

        {/* Right Section - Nav Links and User Icon */}
        <div className="header-right d-flex justify-content-end align-items-center">
          <Nav className="nav-routes align-items-center me-3">
            {isAuthorized("AV_Home_MenuLink") ? <Nav.Link as={NavLink as any} color="#fff" to="/">Home</Nav.Link> : <></>}
          </Nav>
          <Nav className="align-items-center">
            <NavDropdown className="nav-loggedin-user-icon" title={
              getUserIcon(currentUser, currentUserRole, mobileUsers, isIconHovered, setIsIconHovered)
            } id="basic-nav-dropdown">
              <NavDropdown.Item className="dropdown-item-info" style={{ cursor: 'default' }}>{currentUser.displayName}</NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item-info" style={{ cursor: 'default' }}> <strong> {currentUser.cwopa} </strong> </NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item-info" style={{ cursor: 'default' }}> {currentUser.role} </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href={helpFile} target="new">Help</NavDropdown.Item>
              <NavDropdown.Item onClick={logOut}>Sign Out</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
}
export default AppHeader;
